import { useTranslation } from 'react-i18next'

import style from './UndoMapButton.module.css'

interface UndoRedoMapButtonsProps {
  onUndo: () => void
  undoDisabled?: boolean
  onRedo: () => void
  redoDisabled?: boolean
}

const UndoMapButton = ({ onUndo, undoDisabled, onRedo, redoDisabled }: UndoRedoMapButtonsProps) => {
  const { t } = useTranslation()

  return (
    <div className={style.root}>
      {/* Undo Button */}
      <button className={style.button} disabled={undoDisabled} onClick={onUndo} title={t('common.undo') || 'Undo'}>
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="var(--map-ctrl-icon-color, currentColor)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transition: 'transform 0.2s ease' }}
        >
          <path d="M3 7v6h6" />
          <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13" />
        </svg>
      </button>

      {/* Redo Button */}
      <button className={style.button} disabled={redoDisabled} onClick={onRedo} title={t('common.redo') || 'Redo'}>
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="var(--map-ctrl-icon-color, currentColor)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transition: 'transform 0.2s ease' }}
        >
          <path d="M21 7v6h-6" />
          <path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" />
        </svg>
      </button>
    </div>
  )
}

export default UndoMapButton
